module.exports = __webpack_public_path__ + "b2fc158cc225378701e3d50aad402954.png";